import { getCurrentInstance } from 'vue';
import { RailItemResponse } from '@/types/cms';
import { RouteName, routeTo } from '@/router/routes';

export interface CMSItemNavigation {
  openItem: (item: RailItemResponse) => void;
  openCategory: (slug: string) => void;
}

export function useCMSItemNavigation(): CMSItemNavigation {
  const router = getCurrentInstance()?.proxy?.$router;

  const openCategory = (slug: string) => {
    router?.push(routeTo(RouteName.Category, { slug }));
  };

  const openItem = (item: RailItemResponse) => {
    switch (item.type) {
      case 'SERIES':
        router?.push(routeTo(RouteName.Series, { slugOrVID: item.series.slug }));
        return;
      case 'VIDEO':
        router?.push(routeTo(RouteName.Episode, { videoId: item.video.vid }));
        return;
      case 'CATEGORY':
        openCategory(item.category.slug);
        return;
      default:
        // Neither the rails nor the item grids that use this carry LIVE_STREAM.
        // Warn rather than navigate somewhere wrong.
        console.warn(`[cms-item] No destination for item of type "${item.type}"`);
    }
  };

  return { openItem, openCategory };
}
